import React from "react";
import styles from "./fbm-listings-create-page.module.css";
import { useFbmListingContext } from "@/contexts/FbmListingContext";
import FbmListingsPageSteps from "../FbmListingsPageSteps/FbmListingsPageSteps";
import FbmListingsPageActionButtons from "../FbmListingsPageActionButtons/FbmListingsPageActionButtons";
import FbmListingsReviewPage from "../FbmListingsReviewPage/FbmListingsReviewPage";
import FbmListingsList from "../FbmListingsList/FbmListingsList";
import FbmListingsSearch from "../FbmListingsSearch/FbmListingsSearch";
import Flex from "@/components/Flex/Flex";

type FbmListingsCreatePageProps = {};

const FbmListingsCreatePage = ({}: FbmListingsCreatePageProps) => {
  const { fbmListingFlowStep } = useFbmListingContext();

  return (
    <div className={styles.pageContent}>
      <Flex justify="space-between" align="center" className={styles.container}>
        <FbmListingsPageSteps />
        <FbmListingsPageActionButtons />
      </Flex>

      {fbmListingFlowStep === 0 && (
        <div className={styles.createListingsContainer}>
          <FbmListingsSearch />

          <div className={styles.styledCol}>
            <FbmListingsList />
          </div>
        </div>
      )}

      {fbmListingFlowStep === 1 && (
        <FbmListingsReviewPage />
      )}
    </div>
  );
};

export default FbmListingsCreatePage;